export default __webpack_public_path__ + "static/media/sign.b9361011.svg";